export const COLOR_PALETTE = {
  white: "#FFFFFF",
  black: "#1A1A1A",

  grey50: "#F8F8F8",
  grey100: "#F1F5F8",
  grey200: "#E9EDF0",
  grey250: "#EEEEEE",
  grey300: "#E4E7EA",
  grey400: "#D5D8DB",
  grey500: "#C5C9CC",
  grey600: "#9DA1A5",
  grey700: "#6B737A",
  grey800: "#3F4347",
  grey850: "#33373B",
  grey900: "#272B2F",
  green50: "#F5FFFE",
  green100: "#C8FFF4",
  green200: "#9AFFEC",
  green300: "#79EED4",
  green400: "#00D9B0", // brand color
  green500: "#00C5A1",
  green600: "#07B899",
  green700: "#008571",
  green800: "#015C55",
  green900: "#003331",
  green1000: "#009E77",
  blue50: "#FAFBFF",
  blue100: "#D6F4FF",
  blue200: "#B7EBFF",
  blue300: "#7CD3FF",
  blue400: "#4DBAF2",
  blue500: "#309ED6", // brand color
  blue600: "#1989D6",
  blue700: "#0453BB",
  blue800: "#0D2C86",
  blue900: "#001347",
  yellow50: "#FFFCE9",
  yellow100: "#FFFBBE",
  yellow200: "#FFEC7E",
  yellow300: "#FFE255",
  yellow400: "#FFC300", // brand color
  yellow500: "#F0AB00",

  red50: "#FFF5F2",
  red100: "#FED7D1",
  red200: "#FFAFA9",
  red300: "#FF8072",
  red400: "#FF5456",
  red500: "#FF4049", // brand color
  red600: "#F5363F",
  red700: "#D71831",
  red800: "#AF001F",
  red900: "#5F001F",
} as const

export const BRAND_COLORS = {
  night: "#1A1A1A",
  day: "#FFFFFF",
  fire: "#FF4049",
  sun: "#FFC300",
  earth: "#00D9B0",
  sky: "#309ED6",

  //LIGHT
  ["night-light-1"]: "#6B6B6B",
  ["fire-light"]: "#FF7875",
  ["sun-light"]: "#F0BC64",
  ["earth-light"]: "#64FFE2",
  ["sky-light"]: "#70CFFF",

  //DARK
  ["night-light-2"]: "#939393",
  ["day-dark"]: "#EEEEEE",
  ["fire-dark"]: "#C40021",
  ["sun-dark"]: "#BB8C36",
  ["earth-dark"]: "#00C5A1",
  ["sky-dark"]: "#0070A4",
} as const

export type BrandColorsType = keyof typeof BRAND_COLORS
